import React, { ReactNode, useId, useState } from 'react';

import * as S from './styles';
// import { ReactSVG } from "react-svg";

interface IProps {
  label?: string | ReactNode;
  disabled?: boolean | undefined;
  onChange: (e: object) => void;
  style?: object;
  id?: string;
  error?: boolean;
  success?: boolean;
  message?: string | boolean;
  height?: string;
  name?: string;
  onBlur?: (val: object) => void;
  onFocus?: () => void;
  value?: string;
  inputStyle?: object;
  readOnly?: boolean;
  inputSize?: number;
  maxLength?: number;
  // -- //
  refrence?: any;
  className?: string;
  placeholder?: string;
  showHide?: boolean;
  labelStyle?: object;
}

const PasswordInput: React.FC<IProps> = ({
  label,
  id,
  disabled,
  style,
  error,
  success,
  message,
  height,
  onChange,
  name,
  onBlur,
  value,
  inputStyle,
  readOnly,
  inputSize,
  maxLength,
  className,
  refrence,
  onFocus,
  placeholder,
  showHide,
  labelStyle
}) => {
  const autoId = useId();
  const [show, setShow] = useState<boolean>(false);

  /*
   * Reveal is on unless a call site turns it off. It used to be off unless a
   * call site asked for it, which left the login screen — the one place a typo
   * costs a round trip to the server — with no way to check what was typed.
   * `showHide={false}` still switches it off.
   */
  const reveal = showHide !== false;

  return (
    <S.inputContainer
      style={style}
      className={error ? `error ${className}` : success ? `success ${className}` : `${className}`}
    >
      <S.Grid>
        <S.label className="input-label" htmlFor={id ? id : `${autoId}`} style={labelStyle}>
          {label}
        </S.label>
        {/* <S.CopyBtn>
          <S.Img
            src="/icons/stroke/copy.svg"
            // beforeInjection={(svg) => {
            //   svg.setAttribute("stroke", "var(--dark)");
            // }}
          />
        </S.CopyBtn> */}
      </S.Grid>
      <S.InputBox>
        <S.Input
          ref={refrence}
          maxLength={maxLength}
          size={inputSize}
          readOnly={readOnly}
          name={name}
          className={reveal ? 'has-toggle' : ''}
          type={show ? 'text' : 'password'}
          onChange={onChange}
          id={id ? id : `${autoId}`}
          disabled={disabled}
          placeholder={placeholder}
          style={height ? { ...inputStyle, height } : inputStyle}
          onBlur={onBlur}
          onFocus={onFocus}
          value={value}
        />
        {reveal ? (
          <S.ShowHideButton
            type="button"
            onClick={() => setShow(!show)}
            aria-label={show ? 'Hide password' : 'Show password'}
            title={show ? 'Hide password' : 'Show password'}
          >
            <S.Img src={show ? '/icons/eye-hidden.svg' : '/icons/eye.svg'} alt="" />
          </S.ShowHideButton>
        ) : (
          <></>
        )}
      </S.InputBox>

      {message ? (
        <S.message className={error ? 'error-message' : success ? 'success-message' : ''}>{message}</S.message>
      ) : (
        <></>
      )}
    </S.inputContainer>
  );
};

export default PasswordInput;
